import { render } from "./HomeComponent.vue?vue&type=template&id=278264ec&scoped=true"
const script = {}

import "./HomeComponent.vue?vue&type=style&index=0&id=278264ec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-278264ec"]])

export default __exports__